import { render } from "./Warning.vue?vue&type=template&id=3b40c462&scoped=true"
import script from "./Warning.vue?vue&type=script&setup=true&lang=js"
export * from "./Warning.vue?vue&type=script&setup=true&lang=js"

import "./Warning.vue?vue&type=style&index=0&id=3b40c462&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b40c462"],['__file',"src/components/Wishlist/Warning.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b40c462"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b40c462', __exports__)) {
    api.reload('3b40c462', __exports__)
  }
  
  module.hot.accept("./Warning.vue?vue&type=template&id=3b40c462&scoped=true", () => {
    api.rerender('3b40c462', render)
  })

}


export default __exports__